import axios from "axios";
const API_URL = "https://srinivasafleet.com/api";


const authHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getSuppliers = async ({ financialYearId, allYears, status } = {}) => {
    const params = new URLSearchParams();
    if (allYears) params.append("all_years", "true");
    else if (financialYearId) params.append("financial_year_id", financialYearId);
    if (status) params.append("status", status);

    const qs = params.toString();
    const res = await axios.get(`${API_URL}/suppliers/${qs ? `?${qs}` : ""}`, {
        headers: authHeaders(),
    });
    return res.data;
};

export const getSupplierById = async (id) => {
  const response = await axios.get(`${API_URL}/suppliers/${id}`, {
    headers: authHeaders(),
  });
  return response.data;
};

export const createSupplier = async (data) => {
  const response = await axios.post(`${API_URL}/suppliers/`, data, {
    headers: authHeaders(),
  });
  return response.data;
};

export const updateSupplier = async (id, data) => {
  const response = await axios.put(`${API_URL}/suppliers/${id}`, data, {
    headers: authHeaders(),
  });
  return response.data;
};

export const deleteSupplier = async (id) => {
  const response = await axios.delete(`${API_URL}/suppliers/${id}`, {
    headers: authHeaders(),
  });
  return response.data;
};

export const getSupplierTypes = async () => {
  const response = await axios.get(`${API_URL}/suppliers/master-supplier-type`, {
    headers: authHeaders(),
  });
  return response.data;
};

export const getServiceLocations = async () => {
  const response = await axios.get(`${API_URL}/suppliers/master-service-locations`, {
    headers: authHeaders(),
  });
  return response.data;
};

export const getBranches = async (locationId) => {
  const params = new URLSearchParams();
  if (locationId) params.append("location_id", locationId);
  const qs = params.toString();

  const response = await axios.get(
    `${API_URL}/suppliers/master-branch${qs ? `?${qs}` : ""}`,
    { headers: authHeaders() }
  );
  return response.data;
};

export const getStatuses = async () => {
  const response = await axios.get(`${API_URL}/vehicles/master/status`, {
    headers: authHeaders(),
  });
  return response.data;
};

export const getFinancialYears = async () => {
  const response = await axios.get(`${API_URL}/suppliers/master-financial-year`, {
    headers: authHeaders(),
  });
  return response.data;
};


export const uploadSupplierDocument = async (file, field) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await axios.post(
    `${API_URL}/suppliers/upload-document?field=${field}`,
    formData,
    { headers: { ...authHeaders(), "Content-Type": "multipart/form-data" } }
  );
  return response.data;
};


export const uploadSupplierStatement = async (supplierId, year, month, file) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await axios.post(
    `${API_URL}/suppliers/${supplierId}/statements?statement_year=${year}&statement_month=${month}`,
    formData,
    { headers: { ...authHeaders(), "Content-Type": "multipart/form-data" } }
  );
  return response.data; 
};

export const getSupplierStatements = async (supplierId) => {
  const response = await axios.get(`${API_URL}/suppliers/${supplierId}/statements`, {
    headers: authHeaders(),
  });
  return response.data; 
};

export const deleteSupplierStatement = async (supplierId, statementId) => {
  const response = await axios.delete(
    `${API_URL}/suppliers/${supplierId}/statements/${statementId}`,
    { headers: authHeaders() }
  );
  return response.data;
};

export const getSupplierFileDownloadUrl = (fileUrlOrPath) => {
  if (!fileUrlOrPath) return null;
  const relativePath = fileUrlOrPath.replace(/^https?:\/\/[^/]+\//, "");
  return `${API_URL}/suppliers/download-file?path=${encodeURIComponent(relativePath)}`;
};